import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=4b2880a2&scoped=true"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=4b2880a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2880a2",
  null
  
)

export default component.exports